var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpArrowRound(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 11C21.75 16.93 16.93 21.75 11 21.75C5.07 21.75 0.25 16.93 0.25 11C0.249999 5.07 5.07 0.25 11 0.25C16.93 0.249999 21.75 5.07 21.75 11ZM1.75 11C1.75 16.1 5.9 20.25 11 20.25C16.1 20.25 20.25 16.1 20.25 11C20.25 5.9 16.1 1.75 11 1.75C5.9 1.75 1.75 5.9 1.75 11Z",
    fill: "#3583FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2763 12.2601C15.2763 12.4501 15.2062 12.6401 15.0562 12.7901C14.9151 12.9296 14.7247 13.0078 14.5262 13.0078C14.3278 13.0078 14.1374 12.9296 13.9963 12.7901L10.9963 9.79011L7.99625 12.7901C7.85511 12.9296 7.66468 13.0078 7.46625 13.0078C7.26782 13.0078 7.07739 12.9296 6.93625 12.7901C6.64625 12.5001 6.64625 12.0201 6.93625 11.7301L10.4662 8.20011C10.7563 7.91011 11.2362 7.91011 11.5262 8.20011L15.0562 11.7301C15.2062 11.8801 15.2763 12.0701 15.2763 12.2601Z",
    fill: "#3583FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrowRound);
export default __webpack_public_path__ + "static/media/UpArrowRound.eaf0ba66b1fbce921bcad0d156c8664e.svg";
export { ForwardRef as ReactComponent };